import { Component, OnInit } from '@angular/core';
import { InstitutionsService } from '@app/services/institutions/institutions.service';
import { SortService } from '@app/components/sorting/SortService';
import { PdfService } from '@app/services/pdf/pdf.service';
import { MenuItem } from 'primeng/api';
import { CSVDataService } from '@app/export/CSVDataService';
import { Listbox } from 'primeng/listbox';
import { Dropdown } from 'primeng/dropdown';
import { DatePipe } from '@angular/common';
import { AutoCompleteCompleteEvent } from 'primeng/autocomplete';

@Component({
  selector: 'app-getinstitutionsperdistrict',
  templateUrl: './getinstitutionsperdistrict.component.html',
  styleUrls: ['./getinstitutionsperdistrict.component.css']
})
export class GetinstitutionsperdistrictComponent implements OnInit {
  institutionsperdistrict;
  all_institutionsperdistrict;
  items: MenuItem[];
  showSpinner = false;
  districtlist;
value: any;
  constructor(private institutionsService: InstitutionsService, private pdfService: PdfService, private datePipe: DatePipe) {

  }

  ngOnInit() {
    this.search();
    this.GetAllDistrictsAsync();
    this.setItems();
  }

  GetAllDistrictsAsync() {
    this.institutionsService.GetAllDistrictsAsync(0).subscribe(d => {
      this.districtlist = d.sort((a, b) => {
        return SortService.cmpStringsWithNumbers(a.shortName, b.shortName, false);
      });
      this.districtlist.forEach(x => {
        x.districtName = x.shortName;
      });
      this.districtlist.unshift({ id: 0, shortName: null, name: null, seat: null, districtName: null });
    });
  }

  clearFilter(dd: Dropdown) {
    dd.filterValue = '';
    }

  filterDistrict(evt) {

    if (this.all_institutionsperdistrict) {
      this.institutionsperdistrict = this.all_institutionsperdistrict;
    } else {
      this.all_institutionsperdistrict = this.institutionsperdistrict;
    }
    if (evt.value?.districtName !== null && evt.value !== null) {
      this.institutionsperdistrict = this.institutionsperdistrict.filter(d => d.shortName === evt.value.shortName);
    } else {
      this.institutionsperdistrict = this.all_institutionsperdistrict;
    }
  }

  search() {
    this.showSpinner = true;
    this.institutionsService.GetInstitutionsPerDistrictReport(0).subscribe(response => {
      this.institutionsperdistrict = response.sort((a, b) => {
        return SortService.cmpStringsWithNumbers(a.shortName, b.shortName, false);
      });

      this.institutionsperdistrict.forEach(element => {
        element.institutions = element.institutions.sort((a, b) => {
          return SortService.cmpStringsWithNumbers(a.shortName, b.shortName, false);
        });
      });
      this.showSpinner = false;
    });
  }

  
  setItems() {
    this.items = [
      {
        label: 'Excel',
        icon: 'fa fa-file-excel',
        command: () => this.exportToCSV()
      }
    ]
  }

  saveToPDF() {
    const data = document.getElementById('contentToConvert');
    this.pdfService.captureScreen(data, 'p',null);
  }


  exportToCSV() {
    let data: any[] = [];
    this.institutionsperdistrict.forEach(x => {
      const record = {
        col1: x.shortName,
        col2: x.name,
        col3: 'Loge: ' + x.noOfMembersInLoge,
        col4: 'Läger: ' + x.noOfMembersInLager,
        col5: 'Antal (%) i läger: ' + x.percentInLager,
        col6: x.memberFullName
      };
      data.push(record);

      x.institutions.forEach(i => {
        const irecord = {
          col1: i.shortName,
          col2: i.name,
          col3: i.seat,
          col4: i.noOfMembers,
          col5: '',
          col6: ''
        };
        data.push(irecord);
      })

      const emptyrecord = {
        col1: '',
        col2: '',
        col3: '',
        col4: '',
        col5: '',
        col6: ''
      };
      data.push(emptyrecord);
    });

    const firstrow = '';
    const datum = this.datePipe.transform(new Date(), 'yy-MM-dd');
    const filnamn = 'InstitutionerPerDistrikt_' + datum;
    CSVDataService.exportToCsv(filnamn + '.csv', data, firstrow);
  }
}
